module.exports = __webpack_public_path__ + "img/Weapon_267.b1ac1431.png";